
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';

const { shoppingGuide } = api;

@Component({})
export default class ShoppingGuideList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private headers = [
    { text: '名稱', value: 'name', width: '60%' },
    { text: '排序', value: 'sort', width: '10%' },
    { text: '回饋', value: 'pointBackPercentage', width: '10%' },
    { text: '顯示', value: 'isEnabled', width: '10%' },
    { text: '動作', value: 'actions', width: '10%' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async query() {
    const query = {
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    } else {
      await this.requestData();
    }
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await shoppingGuide.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ShoppingGuideList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }

  private async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: (to?: ((vm: ShoppingGuideList) => void) | boolean) => void,
  ) {
    if (to.name === 'shoppingGuideList') await this.requestData();
    await next(true);
  }
}
